import * as DTOS from "../FeralScan.dtos";
import { MapType, LatLong } from "../reducers/map.reducer";


export interface IMapActions {
    type: string;
}

export interface MapAction extends IMapActions {

    //deleteEventRequest deleteEventSuccess
    plotEventId?: number,

    //setMapPositionRequest
    lat?: any,
    lng?: any,

    //toggleMapOptionsRequest
    mapOption?: any,

    //setMapTypeRequest
    mapType?: MapType,

    //toggleMarkerPopupRequest
    marker?: any,

    //showEventRequest
    plot?: DTOS.Plot,

    //deleteEventSuccess
    success?: boolean
}

export interface ToggleNewMarkerPopupRequestAction extends IMapActions {
    latitude?: number;
    longitude?: number;
}

export interface ICacheMapSettingsAction extends IMapActions {
    zoom: number;
    location: LatLong;
}

export const
    DELETE_EVENT_REQUEST = "DELETE_EVENT_REQUEST",
    DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS",
    SHOW_EVENT_REQUEST = "SHOW_EVENT_REQUEST",
    SHOW_PLOT_REQUEST = "SHOW_PLOT_REQUEST",
    HIDE_PLOT_REQUEST = "HIDE_PLOT_REQUEST",
    SET_MAP_POSITION = "SET_MAP_POSITION",
    CACHE_MAP_SETTINGS = "CACHE_MAP_SETTINGS",
    TOGGLE_MARKER_POPUP_REQUEST = "TOGGLE_MARKER_POPUP_REQUEST",
    TOGGLE_NEW_MARKER_POPUP_REQUEST = "TOGGLE_NEW_MARKER_POPUP_REQUEST",
    TOGGLE_MAP_OPTIONS = "TOGGLE_MAP_OPTIONS";

export function setMapPositionRequest(lat, lng): MapAction {
    return {
        type: SET_MAP_POSITION,
        lat,
        lng
    };
}

export function hidePlotRequest(): MapAction {
    return {
        type: HIDE_PLOT_REQUEST,
        plot: undefined
    };
}

export function showPlotRequest(plot: DTOS.Plot): MapAction {
    return {
        type: SHOW_PLOT_REQUEST,
        plot
    };
}

export function toggleNewMarkerPopupRequest(latitude: number, longitude: number): ToggleNewMarkerPopupRequestAction {
    return {
        type: TOGGLE_NEW_MARKER_POPUP_REQUEST,
        latitude,
        longitude
    };
}

export function toggleMapOptionsRequest(mapOption): MapAction {
    return {
        type: TOGGLE_MAP_OPTIONS,
        mapOption
    };
}

export function toggleMarkerPopupRequest(marker): MapAction {
    return {
        type: TOGGLE_MARKER_POPUP_REQUEST,
        marker
    };
}

export function showEventRequest(plot: DTOS.Plot): MapAction {
    return {
        type: SHOW_EVENT_REQUEST,
        plot
    };
}

export function deleteEventRequest(plotEventId: number): MapAction {
    return {
        type: DELETE_EVENT_REQUEST,
        plotEventId
    };
}

export function deleteEventSuccess(response: DTOS.DeletePlotEventResponse): MapAction {
    return {
        type: DELETE_EVENT_SUCCESS,
        plotEventId: response.plotEventId,
        success: response.success
    };
}

export function cacheMapSettingsAction(zoom: number, location: LatLong): ICacheMapSettingsAction {
    return {
        type: CACHE_MAP_SETTINGS,
        zoom: zoom,
        location: location
    };
}